var React = require('react');

function Stocking (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M367.29 0h-288a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zM224 368a111.66 111.66 0 0 0 35.42 81.72L280 436a159.58 159.58 0 0 0 71.2-133.1V257a113.64 113.64 0 0 0-15.2-1 112 112 0 0 0-112 112z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M259.42 449.72l-61.13 40.78a128 128 0 0 1-142-213l39-26V96h255.9v161a113.64 113.64 0 0 0-15.19-1 112 112 0 0 0-76.58 193.72z","className":"fa-primary","key":2})]);
}

Stocking.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Stocking;

Stocking.default = Stocking;
